import { Box, CircularProgress, Stack, Typography } from '@mui/material';
import { IPayslips } from 'API/Paychecks/paychecks';
import { Dictionary } from 'Dictionary';
import { DICTIONARY } from 'Enum';
import { useDictionary } from 'Hooks';
import { AddCommaToNumber } from 'Utils/AddCommaToNumber';

interface IPaychecksChart {
  currentPaycheck: IPayslips | null;
  showPaychecks: boolean;
}
export const PaychecksChart = ({
  currentPaycheck,
  showPaychecks,
}: IPaychecksChart) => {
  const dictionary = useDictionary(Dictionary, DICTIONARY.Home).userPaychecks;

  const paycheckNetDeductionPercent =
    currentPaycheck?.net && currentPaycheck?.deduction
      ? (currentPaycheck.net /
          (currentPaycheck?.net + currentPaycheck?.deduction)) *
        100
      : 1000;

  return (
    <Stack>
      <Box display='flex' flexDirection='column' alignItems='center'>
        <Box position='relative' display='inline-flex'>
          <Box sx={{ transform: 'rotateY(180deg)' }} aria-hidden='true'>
            <CircularProgress
              variant='determinate'
              value={
                paycheckNetDeductionPercent > 95
                  ? (95 / 100) * 100
                  : paycheckNetDeductionPercent
              }
              size={200}
              thickness={6}
              sx={{
                color: '#008F88',
                position: 'absolute',
                zIndex: 1,
                strokeLinecap: 'round',
              }}
            />
            <CircularProgress
              variant='determinate'
              value={100}
              size={200}
              thickness={6}
              sx={{
                color: '#A3D7D4',
              }}
            />
          </Box>

          {/* Text inside the circle */}
          {showPaychecks && (
            <Box
              sx={{
                position: 'absolute',
                width: '100%',
                textAlign: 'center',
                top: '50%',
                left: 0,
                transform: 'translateY(-50%)',
                zIndex: 2,
                fontSize: '20px', // Adjust font size as needed
              }}
            >
              <Typography variant='body2'>
                {currentPaycheck?.net && currentPaycheck?.deduction
                  ? AddCommaToNumber(
                      parseFloat(
                        (
                          currentPaycheck?.net + currentPaycheck?.deduction
                        ).toFixed(2)
                      )
                    )
                  : ''}{' '}
                ₪
              </Typography>
              <Typography variant='body6'>{dictionary.total}</Typography>
            </Box>
          )}
        </Box>
      </Box>
    </Stack>
  );
};
